module.exports = __webpack_public_path__ + "static/media/apps_white_24dp.a9c7c32f.svg";